import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  padding-bottom: 100px; /* 底部添加额外空间，确保最后的元素可以正常滚动到视口中 */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  min-height: 100vh; /* 确保容器有足够高度 */
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
`;

export const Title = styled.h1`
  color: #2c3e50;
  margin: 0;
`;

export const TemplateId = styled.span`
  font-size: 14px;
  color: #6c757d;
  font-family: monospace;
  background: #f8f9fa;
  padding: 4px 8px;
  border-radius: 4px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

export const FloatingButtonGroup = styled.div`
  position: fixed;
  top: 90px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
  background: white;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    top: 80px;
    right: 10px;
    padding: 10px;
  }
`;

export const Button = styled.button`
  padding: 10px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  min-width: 140px;
  text-align: center;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  }

  ${props => props.primary && `
    background: #007bff;
    color: white;
    &:hover { background: #0056b3; }
  `}

  ${props => props.secondary && `
    background: #6c757d;
    color: white;
    &:hover { background: #545b62; }
  `}

  ${props => props.success && `
    background: #28a745;
    color: white;
    &:hover { background: #1e7e34; }
  `}

  ${props => props.danger && `
    background: #dc3545;
    color: white;
    &:hover { background: #bd2130; }
  `}
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }
`;

export const FormSection = styled.div`
  background: white;
  padding: 20px;
  margin-bottom: 30px; /* 增加底部间距，确保各section之间有足够空间 */
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  scroll-margin-top: 120px; /* CSS scroll-margin 属性，确保滚动时有合适的偏移 */
`;

export const SectionTitle = styled.h2`
  color: #2c3e50;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
  
  &:hover {
    color: #007bff;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 15px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #495057;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
  }
`;

export const SectionContainer = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 6px;
  margin-bottom: 20px;
  overflow: hidden;
`;

export const SectionHeader = styled.div`
  background: #f8f9fa;
  padding: 15px;
  font-weight: 500;
  font-size: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;
`;

export const SectionContent = styled.div`
  padding: 15px;
`;

export const QuestionContainer = styled.div`
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 15px;
  overflow: hidden;
  scroll-margin-top: 120px; /* CSS scroll-margin 属性，确保滚动时有合适的偏移 */
`;

export const QuestionHeader = styled.div`
  background: #f1f3f4;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
`;

export const QuestionContent = styled.div`
  padding: 15px;
`;

export const Row = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  
  ${props => props.wrap && `
    flex-wrap: wrap;
  `}
`;

export const Col = styled.div`
  flex: ${props => props.flex || 1};
  min-width: ${props => props.minWidth || 'auto'};
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 8px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  font-weight: normal;
  cursor: pointer;
  margin-bottom: 8px;
`;

export const AddButton = styled(Button)`
  width: 100%;
  margin-top: 10px;
  background: #17a2b8;
  color: white;
  
  &:hover {
    background: #138496;
  }
`;

export const RemoveButton = styled(Button)`
  padding: 5px 10px;
  font-size: 12px;
`;

// Navigation Sidebar Styles
export const NavigationSidebar = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 300px;
  height: 100vh;
  background: white;
  border-right: 1px solid #e9ecef;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    width: 250px;
  }
`;

export const NavigationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
  
  h4 {
    margin: 0;
    color: #495057;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #6c757d;
  padding: 5px;
  border-radius: 3px;
  transition: all 0.2s;
  
  &:hover {
    background: #e9ecef;
    color: #495057;
  }
`;

export const NavigationContent = styled.div`
  padding: 10px 0;
`;

export const NavigationSection = styled.div`
  margin-bottom: 5px;
`;

export const NavigationItem = styled.div`
  padding: 12px 20px;
  cursor: pointer;
  color: #495057;
  font-size: 14px;
  font-weight: ${props => props.isSection ? '600' : '500'};
  transition: all 0.2s;
  border-left: 3px solid transparent;
  position: relative;
  
  &:hover {
    background: #f8f9fa;
    color: #007bff;
    border-left-color: #007bff;
  }
  
  &:active {
    background: #e3f2fd;
    transform: translateX(2px);
  }
  
  ${props => props.isSection && `
    background: #f1f3f4;
    font-weight: 600;
  `}
`;

export const NavigationSubItem = styled.div`
  padding: 8px 20px 8px 40px;
  cursor: pointer;
  color: #6c757d;
  font-size: 13px;
  transition: all 0.2s;
  border-left: 3px solid transparent;
  position: relative;
  
  &:hover {
    background: #f8f9fa;
    color: #007bff;
    border-left-color: #007bff;
  }
  
  &:active {
    background: #e3f2fd;
    transform: translateX(2px);
  }
`;

export const ShowNavigationButton = styled.button`
  position: fixed;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 16px;
  z-index: 999;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
  transition: all 0.2s;
  
  &:hover {
    background: #0056b3;
    transform: translateY(-50%) translateX(5px);
  }
`;

export const MainContent = styled.div`
  margin-left: ${props => props.showNavigation ? '300px' : '0'};
  padding-top: 20px; /* 确保顶部有足够空间 */
  min-height: 100vh; /* 确保内容区域有足够高度 */
  transition: margin-left 0.3s ease;
  
  @media (max-width: 768px) {
    margin-left: ${props => props.showNavigation ? '250px' : '0'};
  }
`;

// Collapsible Section Styles
export const CollapsibleSectionHeader = styled.div`
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CollapseIcon = styled.span`
  display: inline-block;
  margin-right: 10px;
  font-size: 12px;
  transition: transform 0.2s;
  transform: ${props => props.collapsed ? 'rotate(-90deg)' : 'rotate(0deg)'};
  color: #6c757d;
`;

// Section management styles for Final Exam
export const SectionManagementGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
  margin-bottom: 20px;
`;

export const PresetSectionButton = styled(Button)`
  min-width: auto;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CustomSectionForm = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  
  .input-container {
    flex: 1;
  }
`;

export const EmptyStateMessage = styled.div`
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 4px;
  color: #6c757d;
  margin-top: 20px;
  
  p {
    margin: 0;
    font-size: 14px;
  }
`;
